var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBarChart = function SvgBarChart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 511.883 511.883"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00f6f0",
    d: "M138.64 437.228c0 5.89-4.765 10.67-10.67 10.67H63.985c-5.873 0-10.653-4.78-10.653-10.67V309.257c0-5.889 4.78-10.654 10.653-10.654h63.985c5.905 0 10.67 4.766 10.67 10.654z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4FC2E9",
    d: "M245.288 437.228c0 5.89-4.78 10.67-10.67 10.67h-63.985c-5.889 0-10.669-4.78-10.669-10.67V138.639c0-5.89 4.78-10.669 10.669-10.669h63.985c5.89 0 10.67 4.779 10.67 10.669z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#00f6f0",
    d: "M351.92 437.228c0 5.89-4.765 10.67-10.654 10.67h-63.985c-5.89 0-10.67-4.78-10.67-10.67V245.271c0-5.89 4.78-10.653 10.67-10.653h63.984c5.89 0 10.654 4.764 10.654 10.653v191.956h.001z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#69e7ff",
    d: "M458.567 437.228c0 5.89-4.78 10.67-10.669 10.67h-63.986c-5.889 0-10.653-4.78-10.653-10.67V74.654c0-5.89 4.765-10.669 10.653-10.669h63.986c5.889 0 10.669 4.779 10.669 10.669z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#B6C1D4",
    d: "M501.229 426.574H10.67c-5.89 0-10.67 4.764-10.67 10.653s4.78 10.67 10.67 10.67h490.56c5.89 0 10.653-4.78 10.653-10.67s-4.764-10.653-10.654-10.653"
  })));
};
export default SvgBarChart;